export default {
  readMore: {
    en: 'Read more >',
  },
  hide: {
    en: '< Hide',
  },
}
